module.exports = __webpack_public_path__ + "img/castle-bourscheid.fa29ee17.png";